import React from "react";

export default function dispatchOnChange(dispatch:React.Dispatch<string>) {
  return (_event: unknown, newValue?: string) => {
    dispatch(newValue || '');
  }
}